import React, { useEffect } from 'react';
import ParticlesBg from 'particles-bg';
import NavArea from '../Home/Header/NavArea';
import {
  Container,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from 'reactstrap';
import { IsEmpty, Map } from 'react-lodash';
import blogImage from '../../images/undraw_online_articles_79ff.svg';
import Footer from '../Footer/Footer';
import Headroom from 'react-headroom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

const Blog = () => {
  const BlogData = [
    {
      name: '10 Important Topics of JavaScript that you can’t ignore',
      Photo: 'https://i.ibb.co/R6jB38Z/js.png',
      link:
        'https://azimuahamed.medium.com/10-important-topics-of-javascript-that-you-cant-ignore-6c42428b1b5a',
      description:
        'why are you still stuck into the caption ? Don’t you believe this caption? Ok…. let’s start about our 10 selected topics .',
      id: '',
    },
    {
      name: 'Why You Should Learn React Instead Of Learning Other Framework .',
      Photo: 'https://i.ibb.co/W0S8z8r/react.png',
      link:
        'https://azimuahamed.medium.com/why-you-should-learn-react-instead-of-learning-other-framework-3aa3a54d3747',
      description:
        'React is as known as JavaScript library , It is usually used for building user interface’s ….',
      id: '',
    },
    {
      name: 'Some Combinations Of Vanilla JavaScript And ES6…',
      Photo: 'https://i.ibb.co/R63wMZT/es6.png',
      link:
        'https://azimuahamed.medium.com/some-combinations-of-javascript-and-es6-75871c318759',
      description:
        'Wanna know about some cool combinations of JavaScript and ES6',
      id: '',
    },
    {
      name:
        'How To Set An Element Horizontal & Vertical Align Center-CSS Layout ?',
      Photo: 'https://i.ibb.co/S5rcwfG/verticle.jpg',
      link:
        'https://azimuahamed.medium.com/how-to-set-an-element-horizontal-vertical-align-center-css-layout-d6a936b102c8',
      description:
        'Want to an element horizontal & vertical element ? This article is for you.',
      id: '',
    },
  ];
  useEffect(() => {
    AOS.init({
      duration: 2200,
    });

    AOS.refreshHard();
  }, []);
  document.title = 'Azim | | Blogs';
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="Description"
          content="Azim Uddin Ahamed. Web Application Developer  . Textile Engineering Student. Blog Section made by Azim Uddin Ahamed. All about technology and tricks blog. "
          data-react-helmet="true"
        />
      </Helmet>
      <ParticlesBg type="random" bg={true} />
      <Headroom
        style={{
          webkitTransition: 'all .5s ease-in-out',
          mozTransition: 'all .5s ease-in-out',
          oTransition: 'all .5s ease-in-out',
          transition: 'all .5s ease-in-out',
          background: '#0a192f',
          boxShadow: '1px 1px 1px rgba(0,0,0,0.25)',
        }}
      >
        <Container>
          <NavArea />
        </Container>
      </Headroom>
      <Container className="text-center">
        <div>
          <img
            style={{
              height: '70%',
              width: '100%',
            }}
            src={blogImage}
            alt=""
          />
        </div>
        <Row className="my-4">
          <IsEmpty
            value={BlogData}
            yes="Empty list"
            no={() => (
              <Map
                collection={BlogData}
                iteratee={(item, i) => (
                  <Col
                    key={i}
                    className="my-4"
                    lg={4}
                    sm={12}
                    md={{
                      size: 4,
                      order: 1,
                    }}
                  >
                    <Card
                      style={{
                        border: '1px solid #b43838',
                        borderRadius: '8px',
                        boxShadow: '2px 4px 7px gray',
                      }}
                    >
                      <CardImg
                        top
                        width="100%"
                        style={{
                          height: '260px',
                        }}
                        src={item.Photo}
                        alt="Card image cap"
                      />
                      <CardBody>
                        <CardTitle>
                          <h5>{item.name}</h5>
                        </CardTitle>
                        <CardText>{item.description}</CardText>
                        <a target="_blank" rel="noreferrer" href={item.link}>
                          <Button outline color="dark">
                            {' '}
                            &nbsp; &nbsp; Read &nbsp; &nbsp;
                          </Button>
                        </a>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              />
            )}
          />
        </Row>
      </Container>
      <Footer />
    </div>
  );
};

export default Blog;
